(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.getElementById('site-header');
    const mobileToggle = document.querySelector('.header__mobile-toggle');
    const nav = document.querySelector('.header__nav');
    const overlay = document.querySelector('.header__overlay');
    const searchBtn = document.querySelector('.header__search-btn');
    const searchModal = document.getElementById('search-modal');
    const searchClose = document.querySelector('.header__search-close');
    
    let lastScrollTop = 0;
    const delta = 5;

    function handleScroll() {
      let st = window.pageYOffset || document.documentElement.scrollTop;
      
      // 1. Cor de Fundo
      if (st > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }

      // 2. Esconder/Mostrar + FECHAR MENU
      if (Math.abs(lastScrollTop - st) <= delta) return;

      if (st > lastScrollTop && st > 80) {
         // ROLAR PARA BAIXO: Esconde Header e Fecha Menu
         header.classList.add('header--hidden');
         
         if (nav.classList.contains('active')) {
             mobileToggle.classList.remove('active');
             nav.classList.remove('active');
             if(overlay) overlay.classList.remove('active');
             
             // Reseta os acordeões
             const menuItems = document.querySelectorAll('.header__menu-item');
             menuItems.forEach(item => item.classList.remove('active'));
         }
         
      } else {
         // ROLAR PARA CIMA: Mostra Header
         if(st + window.innerHeight < document.body.scrollHeight) {
            header.classList.remove('header--hidden');
         }
      }

      lastScrollTop = st;
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    if (mobileToggle) {
      mobileToggle.addEventListener('click', function() {
        this.classList.toggle('active');
        nav.classList.toggle('active');
        
        if (nav.classList.contains('active')) {
             // ABRIR
             header.classList.add('scrolled');
             header.classList.remove('header--hidden'); 
             if(overlay) overlay.classList.add('active');
             const toggleSpans = this.querySelectorAll('span');
             toggleSpans.forEach(span => span.style.backgroundColor = '#000');
        } else {
             // FECHAR
             if(overlay) overlay.classList.remove('active');
             if (window.scrollY <= 50) {
                 header.classList.remove('scrolled');
                 const toggleSpans = this.querySelectorAll('span');
                 toggleSpans.forEach(span => span.style.backgroundColor = '');
             }
        }
      });
    }
    
    if (overlay) {
        overlay.addEventListener('click', function() {
            mobileToggle.classList.remove('active');
            nav.classList.remove('active');
            overlay.classList.remove('active');
            
            if (window.scrollY <= 50) {
                 header.classList.remove('scrolled');
                 const toggleSpans = mobileToggle.querySelectorAll('span');
                 toggleSpans.forEach(span => span.style.backgroundColor = '');
             }
        });
    }

    // ACORDEÃO (Accordion)
    const menuItems = document.querySelectorAll('.header__menu-item');
    menuItems.forEach(item => {
      const link = item.querySelector('.header__menu-link');
      if (link && item.querySelector('.header__dropdown')) {
        link.addEventListener('click', function(e) {
          if (window.innerWidth <= 900) {
            e.preventDefault();
            
            const isAlreadyOpen = item.classList.contains('active');
            
            // 1. FECHA OUTROS
            menuItems.forEach(otherItem => {
                otherItem.classList.remove('active');
            });
            
            // 2. ABRE ESTE
            if (!isAlreadyOpen) {
                item.classList.add('active');
            }
          }
        });
      }
    });

    if (searchBtn) {
      searchBtn.addEventListener('click', function(e) {
        e.preventDefault();
        searchModal.classList.add('active');
      });
    }
    if (searchClose) {
      searchClose.addEventListener('click', function() {
        searchModal.classList.remove('active');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
